import { render, staticRenderFns } from "./IdVerifyCert.vue?vue&type=template&id=6ce146b3&scoped=true&"
import script from "./IdVerifyCert.vue?vue&type=script&lang=js&"
export * from "./IdVerifyCert.vue?vue&type=script&lang=js&"
import style0 from "./IdVerifyCert.vue?vue&type=style&index=0&id=6ce146b3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce146b3",
  null
  
)

export default component.exports